(function () {
  'use strict';

  angular
    .module('configuracoesEvento', ['restangular']);
}());
